export default __webpack_public_path__ + "static/media/floh_sharp_hand_sanitizer_with_70_alcohol_spearmint_essential_oil_750_ml_0_0.6fbcb966.dib";